import React from 'react';

/** BarRow — single horizontal bar with label + value, used in the agent popularity leaderboard. */
export const BarRow = ({ label, sub, value, max, color = '#FF6B1A', rank, testid }) => {
  const pct = max > 0 ? Math.max(2, Math.round((value / max) * 100)) : 0;
  return (
    <div className="flex items-center gap-3 py-2" data-testid={testid}>
      <div className="mono text-[10px] text-white/40 w-6 shrink-0">#{rank}</div>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline justify-between gap-2">
          <div className="text-xs text-white/90 truncate font-medium">{label}</div>
          <div className="mono text-xs text-white/80 shrink-0">{Number(value).toLocaleString()}</div>
        </div>
        <div className="h-1.5 mt-1 rounded-full bg-white/5 overflow-hidden">
          <div
            className="h-full rounded-full"
            style={{
              width: `${pct}%`,
              background: `linear-gradient(90deg, ${color}, ${color}CC)`,
              boxShadow: `0 0 10px ${color}55`,
              transition: 'width 600ms cubic-bezier(.2,.9,.2,1)',
            }}
          />
        </div>
        {sub && <div className="text-[10px] text-white/40 mt-0.5 truncate">{sub}</div>}
      </div>
    </div>
  );
};

export default BarRow;
